import { renderReactComponentInElement } from "$utils/react";
import { NewProject } from "../views/NewProject";

let reactRoot = undefined;
reactRoot = renderReactComponentInElement(NewProject, 'root', {}, reactRoot)